<template>
  <div class="mb-20">
    <sss-header />

    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>

    <footer class="mt-4 pt-4 border-t border-muted-300 dark:border-muted-600">
      <color-switcher />
    </footer>
  </div>
</template>

<script>
export default {
  name: 'DefaultViewComponent',
  components: {
    ColorSwitcher: () => import('@/components/utils/ColorSwitcher')
  }
};
</script>

<style scoped>

</style>
